"use client";
import { createContext } from 'react';

const MotionContext = createContext({});

export { MotionContext };
